module.exports = __webpack_public_path__ + "img/today-earn.d0199bf5.svg";